import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import StyledButton from './DestinationPageButton.styles';

var DestinationPageButton = function DestinationPageButton(props) {
  var pageNumber = props.pageNumber,
      text = props.text,
      domProps = _objectWithoutProperties(props, ["pageNumber", "text"]);

  var ariaLabel = "Go to Page ".concat(text);
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    pageNumber: pageNumber
  }, domProps, {
    "aria-label": ariaLabel,
    "tab-index": "0"
  }), text);
};

export default DestinationPageButton;